declare const __SHELL_CSS__: string
export const ShellStyles: string = typeof __SHELL_CSS__ !== 'undefined' ? __SHELL_CSS__ : ''
